












import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";

import EventBus from "@/utils/eventBus";

@Component({ components: {} })
export default class MoreOption extends Vue {
  @Prop({ default: "" })
  private type?: string;
  @Prop({ default: "" })
  private singlePrice?: string;

  private textColor: string = "";

  private payload: any = {
    show: true,
    type: "",
    singlePrice: 0
  };

  @Watch("type", { immediate: true })
  private getTextColor() {
    let offertype = this.type;
    if (offertype === "goldenFollower") {
      offertype = "golden_follow";
    }
    this.payload.type = offertype;
    this.payload.singlePrice = this.singlePrice;
    switch (true) {
      case offertype === "follow":
        this.textColor = "rgb(79,121,255)";
        break;
      case offertype === "golden_follow":
        this.textColor = "rgb(255,193,5)";
        break;
      case offertype === "like":
        this.textColor = "rgb(255,59,48)";
        break;
      case offertype === "comment":
        this.textColor = "rgb(23,195,150)";
        break;
      case offertype === "view":
        this.textColor = "rgb(88,86,214)";
        break;
      default:
        return;
    }
    return "";
  }

  // @Watch("singlePrice", { immediate: true })
  // private getSinglePrice(val: any) {
  //     console.log('val   ```````    ',val)
  //     this.payload.coin = val;
  // }

  private getNow() {
    EventBus.$emit("get-now", this.payload);
  }
  // private activated() {
  //     console.log('activated·······',this.singlePrice)
  // }
}
